function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ajaxRequest } from './util/request';
import { documentVisibilityChange } from './util/config';
import { isInGaoTuAndroidApp, isInGaoTuIOSApp, isTestReg } from './util/env';
import debounce from './util/debounce';
import { on } from './util/dom';
import { parse as parseQuery } from './util/json';
import onRouteChange from './util/onRouteChange';
import { isPlainObj } from './util/appCommonParam';
var isClient = typeof window !== 'undefined';
var commonFields = ['version', 'p_client', 'os'];
var connectUUId = '';
var getCompassConfigApi = '';
var postPageConfig = ''; // 罗盘对H5页面的类型标记为2，客户端为1

var H5PageType = '2';
var pageShowEventId = '10299178009782272';
var compassBPConfig = {};
var clientInfo = {};
/**
 * 初始化上报相关参数和变量，否则服务端渲染会导致部分变量取不到报错
 */

function initTrackCtx() {
  var isTestEnv = isTestReg.test(location.host) ? 'test-' : '';
  var _location = location,
      protocol = _location.protocol;
  getCompassConfigApi = "".concat(protocol, "//").concat(isTestEnv, "compass-api.baijia.com/compass-api/ext/api/getCompassBPConfig");
  postPageConfig = "".concat(protocol, "//").concat(isTestEnv, "compass.baijia.com/compass/api/extApi/bpAppDataUpload");
  initClientInfo();
}
/**
 * 保存一下当前接口需要的客户端信息
 */


function initClientInfo() {
  var queryObj = parseQuery(location.search.slice(1));
  commonFields.forEach(function (key) {
    clientInfo[key] = queryObj[key];
  });

  if (clientInfo.version && clientInfo.p_client && clientInfo.os) {
    localStorage.setItem('clientInfo', JSON.stringify(clientInfo));
  } else {
    try {
      clientInfo = JSON.parse(localStorage.getItem('clientInfo')) || {};
    } catch (e) {
      console.error('localStorage.getItem("clientInfo") err', e);
    }
  } // connectUUId 用来标识罗盘开启了配置模式


  connectUUId = queryObj.connectUUId || sessionStorage.getItem('connectUUId') || '';

  if (connectUUId) {
    sessionStorage.setItem('connectUUId', connectUUId);
  }
}
/**
 * 将url中的path 进行压缩，将动态参数（数字）进行统一替换，变成一条路由  /category/22 /category/23 => /category/*
 * 如果有非数字的动态参数（/staticpathname/dynamicParam1/dynamicParam2），暂不处理
 *
 * @param {string} path 当前页面的pathname
 */


function compressPath() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.pathname;
  return location.pathname.split('/').map(function (part) {
    return part && /\d+/.test(part) ? '*' : part;
  }).join('/');
}
/**
 * 通过接口获取所有H5项目页面的配置信息
 */


function getCompassTrackConfig() {
  try {
    compassBPConfig = isPlainObj(compassBPConfig) ? compassBPConfig : JSON.parse(sessionStorage.getItem('CompassBPConfig')) || {};
  } catch (e) {
    console.log('JSON.parse(sessionStorage.getItem("CompassBPConfig"))', e);
  } // 如果本地还存在配置，则不会再取一次了


  if (isPlainObj(compassBPConfig)) {
    return;
  } // 在客户端内，且有合法的配置信息


  if (clientInfo.p_client && clientInfo.version && clientInfo.os) {
    ajaxRequest({
      url: getCompassConfigApi,
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        pageType: H5PageType,
        pOs: clientInfo.os,
        pClient: clientInfo.p_client,
        pVersion: clientInfo.version,
        configVersion: '1'
      }),
      callback: function callback(error, response) {
        if (error) {
          return;
        }

        var _response$data = response.data,
            data = _response$data === void 0 ? {} : _response$data,
            _response$status = response.status,
            status = _response$status === void 0 ? 200 : _response$status;

        if (+status === 200 && +data.code === 0) {
          compassBPConfig = data.data;
          sessionStorage.setItem('CompassBPConfig', JSON.stringify(data.data));
        }
      }
    });
  }
}
/**
 * 配置模式下，上报页面的信息给罗盘
 */


function uploadPageInfoToCompass() {
  if (connectUUId) {
    // 实时获取页面query
    var queryObj = parseQuery(location.search.slice(1));
    var dynamicProperties = Object.keys(queryObj).map(function (key) {
      return {
        propertyName: "".concat(key)
      };
    });

    window.compassTrackScreenShotCallback = function (res) {
      try {
        var img_url = res.img_url;

        if (img_url) {
          ajaxRequest({
            method: 'POST',
            url: postPageConfig,
            headers: {
              'content-type': 'application/json'
            },
            data: JSON.stringify({
              data: {
                pageType: H5PageType,
                imgUrl: img_url,
                dynamicProperty: dynamicProperties,
                // [
                // 暂不支持下面上报方式
                // {
                //     "page" : {
                //         propertyName : '页面来源',
                //         propertyPath: 'subject.subjhectid'
                //     }
                // },
                // 先支持下面的上报动态属性信息方式
                // {
                //     propertyName: "isNavigaitonLeftButtonClose"
                // }
                // ],
                pageName: document.title,
                clientPagePath: location.host + compressPath()
              },
              uuid: connectUUId
            }),
            callback: function callback(error, response) {
              var _response$data2;

              if (error) {
                return;
              }

              if (((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) !== 0) {
                // eslint-disable-next-line no-alert
                // alert(res.msg);
                sessionStorage.removeItem('connectUUId');
              }
            }
          });
        }
      } catch (e) {
        console.log('compassTrackScreenShotCallback img err ', e);
      }
    };

    postMessageToNative({
      type: 'screenshot'
    });
  }
}
/**
 * 根据客户端类型来判断使用什么样的端能力来上报页面展现和停留信息
 */


function postMessageToNative() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isInGaoTuAndroidApp) {
    var _window, _window$hubbleDataNat;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$hubbleDataNat = _window.hubbleDataNativeTracker) === null || _window$hubbleDataNat === void 0 ? void 0 : _window$hubbleDataNat.trackFromH5WithEvent(JSON.stringify(json));
  } else if (isInGaoTuIOSApp) {
    var _window2, _window2$webkit, _window2$webkit$messa, _window2$webkit$messa2;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$webkit = _window2.webkit) === null || _window2$webkit === void 0 ? void 0 : (_window2$webkit$messa = _window2$webkit.messageHandlers) === null || _window2$webkit$messa === void 0 ? void 0 : (_window2$webkit$messa2 = _window2$webkit$messa.hubbleDataNativeTracker) === null || _window2$webkit$messa2 === void 0 ? void 0 : _window2$webkit$messa2.postMessage(JSON.stringify(json));
  }
}
/**
 * 发送展现日志
 */


function sendPVTrackLog() {
  if (document.visibilityState !== 'visible') {
    return;
  }

  var _compassBPConfig = compassBPConfig,
      _compassBPConfig$page = _compassBPConfig.page,
      page = _compassBPConfig$page === void 0 ? {} : _compassBPConfig$page;
  var currentPath = location.host + compressPath(); // 默认上报每个页面的展现日志，除非配置不上报

  if (page[currentPath] && page[currentPath].pageViewEnable === false) {
    return;
  }

  var _ref = page[currentPath] || {},
      _ref$customParam = _ref.customParam,
      customParam = _ref$customParam === void 0 ? {} : _ref$customParam,
      _ref$pageParam = _ref.pageParam,
      pageParam = _ref$pageParam === void 0 ? {} : _ref$pageParam;

  var querys = parseQuery(location.search.slice(1)); // 动态参数这里规则有点复杂
  // 接口数据 pageParam: {grade: {propertyName: "年级", propertyPath: "gradepath"}}
  // propertyPath 为自定义的取值的路径，需要开发伙伴协同配置才可以，目前H5支持的动态参数都是url上的query，以后可能会支持从页面的元素中取值，需要提前定义好规则
  // 比如 规则一 [url.query]
  // 比如 规则二 [$('.xxx')]
  // 以上规则等待后续拓展
  // 目前只默认支持从 query 中取值

  var dynamicProperties = Object.keys(pageParam).map(function (logKey) {
    return {
      logKey: querys[logKey]
    };
  }) || [{}]; // 调用端能力上报日志

  postMessageToNative({
    type: 'pv',
    data: _objectSpread(_objectSpread({
      // eslint-disable-next-line quote-props
      'event_id': pageShowEventId,
      track_page_path: location.host + compressPath(),
      track_web_url: location.href,
      track_page_title: document.title
    }, customParam), dynamicProperties)
  });
}
/**
 * 开始配置
 */


var debouncedSendPVTrackLog = debounce(sendPVTrackLog);

function startTrack() {
  if (isClient) {
    initTrackCtx();
    getCompassTrackConfig();
    on(document, documentVisibilityChange, function (e) {
      sendPVTrackLog();
    }); // 监听路由变动

    on(window, 'load', function (e) {
      debouncedSendPVTrackLog(); // 配置模式才会上报

      uploadPageInfoToCompass();
    }, {
      passive: true
    });
    onRouteChange(function (e) {
      debouncedSendPVTrackLog(); // 配置模式才会上报

      uploadPageInfoToCompass();
    });
  }
}

export default startTrack;